import axios from "axios";

import {
  ageAnswer,
  HttpCodes,
  joinQuestions,
  joinStudyState,
  SimpleQuestion,
  trials,
} from "./constants";

const STUDY = "STUDY";
const WELCOME = "WELCOME";
const ELIGIBILITY = "ELIGIBILITY";
const AGREEMENT_READ = "AGREEMENT_READ";
const AGREEMENT_CONFIRM = "AGREEMENT_CONFIRM";
const REGISTRATION_AGE = "REGISTRATION_AGE";
const REGISTRATION_PARTICIPANT = "REGISTRATION_PARTICIPANT";
const REGISTRATION_CONTACT = "REGISTRATION_CONTACT";
const REGISTRATION_PHYSICIAN = "REGISTRATION_PHYSICIAN";
const SUCCESS = "SUCCESS";
const ERROR = "ERROR";

export default function joinReducer(
  state = {
    step: joinQuestions.study,
    study: trials.notReplied.value,
    eligibility: {
      age: SimpleQuestion.notReplied,
      contact: SimpleQuestion.notReplied,
    },
    agreement: SimpleQuestion.notReplied,
    age: ageAnswer.notReplied,
    personal: {
      firstName: "",
      lastName: "",
      age: 0,
      legalGuardianFirstName: "",
      legalGuardianLastName: "",
    },
    personalContact: {
      email: "",
      phone: "",
      address: "",
      address2: "",
      city: "",
      state: joinStudyState.notReplied.value,
      zipCode: "",
    },
    physicianContact: {
      name: "",
      institution: "",
      email: "",
      phone: "",
      address: "",
      address2: "",
      city: "",
      state: joinStudyState.notReplied.value,
      zipCode: "",
    },
    status: 0,
    error: "",
  },
  action
) {
  switch (action.type) {
    case STUDY:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        step: action.step,
        study: action.data,
      };
    case WELCOME:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        step: action.step,
      };
    case ELIGIBILITY:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        step: action.step,
        eligibility: action.data,
      };
    case AGREEMENT_READ:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        step: action.step,
      };
    case AGREEMENT_CONFIRM:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        step: action.step,
        agreement: action.data,
      };
    case REGISTRATION_AGE:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        step: action.step,
        age: action.data,
      };
    case REGISTRATION_PARTICIPANT:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        step: action.step,
        personal: action.data,
      };
    case REGISTRATION_CONTACT:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        step: action.step,
        personalContact: action.data,
      };
    case REGISTRATION_PHYSICIAN:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        step: action.step,
        physicianContact: action.data,
      };
    case SUCCESS:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        step: action.step,
      };
    case ERROR:
      document.getElementById("root").scrollTop = 0;
      return {
        ...state,
        error: action.data.error,
      };
    default: {
      return {
        ...state,
      };
    }
  }
}

export const go = (save, step, values) => async (dispatch, state) => {
  switch (save) {
    case joinQuestions.study:
      return dispatch({
        ...state,
        step,
        data: values,
        type: STUDY,
      });
    case joinQuestions.welcome:
      return dispatch({
        ...state,
        step,
        type: WELCOME,
      });
    case joinQuestions.eligibility:
      return dispatch({
        ...state,
        step,
        data: values,
        type: ELIGIBILITY,
      });
    case joinQuestions.agreement.read:
      return dispatch({
        ...state,
        step,
        type: AGREEMENT_READ,
      });
    case joinQuestions.agreement.confirm:
      return dispatch({
        ...state,
        step,
        data: values,
        type: AGREEMENT_CONFIRM,
      });
    case joinQuestions.registration.age:
      return dispatch({
        ...state,
        step,
        data: values,
        type: REGISTRATION_AGE,
      });
    case joinQuestions.registration.personal:
      return dispatch({
        ...state,
        step,
        data: values,
        type: REGISTRATION_PARTICIPANT,
      });
    case joinQuestions.registration.contact:
      return dispatch({
        ...state,
        step,
        data: values,
        type: REGISTRATION_CONTACT,
      });
    case joinQuestions.registration.physician:
      return dispatch({
        ...state,
        step,
        data: values,
        type: REGISTRATION_PHYSICIAN,
      });
    case joinQuestions.registration.confirm:
      return axios
        .post(`/api/join`, buildRequestSubmission(state))
        .then(() => {
          return dispatch({
            type: SUCCESS,
            step,
          });
        })
        .catch((error) => {
          const status = error.response.status;
          if (status === HttpCodes.FORBIDDEN) {
            return dispatch({
              type: ERROR,
              data: { error: "Participant already joined study." },
            });
          }
          return dispatch({
            type: ERROR,
            data: {
              error:
                "An error occurred while trying to submit your request. Please contact administrator.",
            },
          });
        });
    default:
      return dispatch({
        type: "NONE",
      });
  }
};

const buildRequestSubmission = (state) => {
  let { study, personal, age, personalContact, physicianContact } =
    state().joinReducer;

  return {
    trial: study,
    age: age,
    participant: {
      firstName: personal.firstName,
      lastName: personal.lastName,
      age: personal.age,
    },
    contact: {
      email: personalContact.email,
      phone: personalContact.phone,
      address: personalContact.address,
      zip: personalContact.zip,
      stateProvince: personalContact.stateProvince,
    },
    physician: {
      name: physicianContact.name,
      institution: physicianContact.institution,
      email: physicianContact.email,
      phone: physicianContact.phone,
      address: physicianContact.address,
      city: physicianContact.city,
      stateProvince: physicianContact.stateProvince,
      zip: physicianContact.zip,
    },
  };
};

export const mapStateToPropsJoin = (state) => {
  const {
    status,
    error,
    study,
    eligibility,
    agreement,
    age,
    personal,
    personalContact,
    physicianContact,
    step,
  } = state.joinReducer;
  return {
    study,
    eligibility,
    agreement,
    age,
    personal,
    personalContact,
    physicianContact,
    step,
    status,
    error,
  };
};

export const mapDispatchToPropsJoin = { go };
